
export class BuzonModel{
    cobro:string;
    fechaCobro:string;
    obsrvacino:string;
    existeError: boolean;
    mensaje: string;
}